import styles from './AttachmentsTabPanel.module.scss';

import { Attachments } from '@work4all/components/lib/components/attachments/Attachments';

import { useTableLayoutState } from '../../../../../../../../components/data-tables/table-layout';
import { Panel } from '../../../../../components/panel/Panel';
import { useMaskContext } from '../../../../../hooks/mask-context';

export const AttachmentsTabPanel = () => {
  const [tableLayout] = useTableLayoutState();
  const mask = useMaskContext();
  return (
    <Panel className={styles.maxHeight}>
      <Attachments entity={mask.entity} tableLayout={tableLayout} />
    </Panel>
  );
};
